<app-breadcrumb [title]="'Plan de competencia anual'" [items]="['Pesv']"
    [active_item]="'Plan de competencia anual'"></app-breadcrumb>

<div class="container-fluid programa-form-wrap">

    <!-- Tarjetas resumen -->
    <div class="row g-3 mb-3" *ngIf="!cargandoListado">
        <div class="col-md-4">
            <div class="card shadow-sm border-0 h-100 stat-card stat-card--total">
                <div class="card-body d-flex align-items-center">
                    <i class="icofont icofont-file-document stat-card__icon"></i>
                    <div>
                        <div class="stat-card__value">{{ totalPlanes }}</div>
                        <div class="stat-card__label">Planes registrados</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card shadow-sm border-0 h-100 stat-card stat-card--activos">
                <div class="card-body d-flex align-items-center">
                    <i class="icofont icofont-check-circled stat-card__icon"></i>
                    <div>
                        <div class="stat-card__value">{{ totalActivos }}</div>
                        <div class="stat-card__label">Planes activos</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card shadow-sm border-0 h-100 stat-card stat-card--vigente">
                <div class="card-body d-flex align-items-center">
                    <i class="icofont icofont-calendar stat-card__icon"></i>
                    <div>
                        <div class="stat-card__value">
                            {{ planVigenteAnioActual ? (planVigenteAnioActual.fecha_inicio | date:'yyyy') : '—' }}
                        </div>
                        <div class="stat-card__label">
                            {{ planVigenteAnioActual ? 'Plan vigente del año actual' : 'Sin plan vigente este año' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <i class="icofont icofont-calendar me-2"></i>
                <h5 class="mb-0"><strong>PLAN DE COMPETENCIA ANUAL</strong></h5>
            </div>
        </div>

        <div class="card-body">

            <div *ngIf="cargandoListado" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-2 mb-0">Cargando información...</p>
            </div>

            <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                        <option [ngValue]="null">Todos</option>
                        <option [ngValue]="1">Activos</option>
                        <option [ngValue]="0">Inactivos</option>
                    </select>
                </div>
                <div class="col-md-4 ms-auto">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Buscar por objetivo..."
                            [(ngModel)]="filtro" (input)="aplicarFiltro()" />
                        <span class="input-group-text">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                </div>
            </div>

            <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                <table id="tblPlanCompetenciaAnual" class="table table-bordered table-hover align-middle">
                    <thead class="bg-primary text-white">
                        <tr>
                            <th class="text-center" style="width: 35%;">OBJETIVO</th>
                            <th class="text-center" style="width: 13%;">METAS</th>
                            <th class="text-center" style="width: 13%;">FECHA INICIO</th>
                            <th class="text-center" style="width: 13%;">FECHA FIN</th>
                            <th class="text-center" style="width: 10%;">ESTADO</th>
                            <th class="text-center" style="width: 16%;">ACCIONES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let plan of planesFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }; trackBy: trackByPlanId">
                            <td class="text-black objetivo-cell" [ngbTooltip]="plan.objetivo" container="body">
                                {{ plan.objetivo }}
                            </td>
                            <td class="text-center">
                                <span class="badge rounded-pill bg-info-subtle text-info-emphasis">
                                    {{ plan.MetasPlanCompetenciaData?.length || 0 }} metas
                                </span>
                            </td>
                            <td class="text-center text-black">{{ plan.fecha_inicio | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center text-black">{{ plan.fecha_fin | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">
                                <span class="badge rounded-pill"
                                    [ngClass]="plan.estado === 1 ? 'bg-success' : 'bg-secondary'">
                                    {{ plan.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                </span>
                            </td>
                            <td class="text-center">
                                <div class="d-flex justify-content-center gap-1">
                                    <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                        ngbTooltip="Editar" (click)="abrirModalEditar(modalPlan, plan)">
                                        <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                        ngbTooltip="Exportar cronograma anual (Excel)" [disabled]="generandoExcel"
                                        (click)="exportarCronogramaExcel(plan)">
                                        <i class="icofont icofont-file-excel" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                        *ngIf="plan.estado === 1" ngbTooltip="Inactivar"
                                        (click)="cambiarEstado(plan, 0)">
                                        <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                        *ngIf="plan.estado !== 1" ngbTooltip="Activar"
                                        (click)="cambiarEstado(plan, 1)">
                                        <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div *ngIf="planesFiltrados.length === 0" class="text-center py-4 text-primary">
                    <i class="icofont icofont-search-document" style="font-size: 1.5rem;"></i>
                    <p class="mb-0 mt-2">No hay planes de competencia anual registrados.</p>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-4">
                <div class="d-flex align-items-center">
                    <label for="pageSizePlan" class="me-2">Mostrar:</label>
                    <select id="pageSizePlan" class="form-select w-auto" [(ngModel)]="pageSize"
                        (change)="page = 1">
                        <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                    </select>
                    <span class="ms-2">registros por página</span>
                </div>

                <div class="text-center flex-grow-1">
                    Total Registros:
                    <a class="badge badge-primary"><b>{{ planesFiltrados?.length || 0 }}</b></a>
                </div>

                <div class="text-end paginador-personalizado">
                    <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                        [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                </div>
            </div>

            <div class="mt-4">
                <div class="btn-showcase text-center">
                    <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                        (click)="exportarExcel('tblPlanCompetenciaAnual','plan_competencia_anual')">
                        <i class="icofont icofont-file-excel"></i> EXCEL
                    </button>
                    <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                        (click)="exportToPDF('tblPlanCompetenciaAnual','plan_competencia_anual','Plan de competencia anual')">
                        <i class="icofont icofont-file-pdf"></i> PDF
                    </button>
                    <button class="btn btn-outline-primary-2x" type="button"
                        (click)="abrirModalCrear(modalPlan)">
                        <i class="icofont icofont-plus me-1"></i> Nuevo plan
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- Modal Crear / Editar -->
<ng-template #modalPlan let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="icofont" [ngClass]="modoEdicion ? 'icofont-edit' : 'icofont-plus'" style="margin-right: 8px;"></i>
            {{ modoEdicion ? 'Editar plan de competencia anual' : 'Nuevo plan de competencia anual' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <form [formGroup]="planForm" novalidate>
        <div class="modal-body">

            <div class="form-section">
                <div class="form-section__title">
                    <i class="icofont icofont-info-circle me-1"></i>Datos del plan
                </div>

                <div class="mb-3">
                    <label class="form-label text-black">
                        Objetivo <span class="text-danger">*</span>
                    </label>
                    <textarea class="form-control" rows="3" formControlName="objetivo"
                        placeholder="Describe el objetivo del plan de competencia anual..."
                        [class.is-invalid]="planForm.get('objetivo')?.invalid && planForm.get('objetivo')?.touched">
                    </textarea>
                    <div class="invalid-feedback"
                        *ngIf="planForm.get('objetivo')?.invalid && planForm.get('objetivo')?.touched">
                        El objetivo es obligatorio (máx. 500 caracteres).
                    </div>
                </div>

                <div class="mb-1">
                    <label class="form-label text-black">
                        Año del plan <span class="text-danger">*</span>
                    </label>
                    <select class="form-select" formControlName="anio"
                        [class.is-invalid]="planForm.get('anio')?.invalid && planForm.get('anio')?.touched">
                        <option [ngValue]="null" disabled>Seleccione el año...</option>
                        <option *ngFor="let a of anios" [ngValue]="a">{{ a }}</option>
                    </select>
                    <div class="invalid-feedback" *ngIf="planForm.get('anio')?.invalid && planForm.get('anio')?.touched">
                        Selecciona el año del plan.
                    </div>
                    <small class="text-secondary">
                        El plan siempre cubre el año completo: 1 de enero al 31 de diciembre.
                    </small>
                </div>

                <div class="row mt-3" *ngIf="planForm.get('fecha_inicio')?.value">
                    <div class="col-md-6 mb-3">
                        <label class="form-label text-black">Fecha inicio</label>
                        <input type="date" class="form-control" formControlName="fecha_inicio" readonly tabindex="-1" />
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label text-black">Fecha fin</label>
                        <input type="date" class="form-control" formControlName="fecha_fin" readonly tabindex="-1" />
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="form-section__title d-flex justify-content-between align-items-center">
                    <span><i class="icofont icofont-flag me-1"></i>Metas <span class="text-danger">*</span></span>
                    <button type="button" class="btn btn-sm btn-outline-primary rounded-pill" (click)="agregarMeta()">
                        <i class="icofont icofont-plus me-1"></i>Agregar meta
                    </button>
                </div>

                <div formArrayName="metas">
                    <div class="input-group mb-2 meta-row" *ngFor="let metaCtrl of metasArray.controls; let i = index; trackBy: trackByIndex">
                        <span class="input-group-text meta-row__index">{{ i + 1 }}</span>
                        <input type="text" class="form-control" [formControlName]="i" maxlength="500"
                            placeholder="Escriba la meta {{ i + 1 }}..."
                            [class.is-invalid]="metaCtrl.invalid && metaCtrl.touched" />
                        <button type="button" class="btn btn-outline-danger" ngbTooltip="Quitar meta" (click)="eliminarMeta(i)">
                            <i class="icofont icofont-trash"></i>
                        </button>
                        <div class="invalid-feedback" *ngIf="metaCtrl.invalid && metaCtrl.touched">
                            La meta es obligatoria (máx. 500 caracteres).
                        </div>
                    </div>
                </div>

                <small class="text-secondary d-block">
                    Agrega tantas metas como necesites para el plan de competencia anual.
                </small>
            </div>

        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
                [disabled]="guardando">Cancelar</button>
            <button type="button" class="btn btn-primary" (click)="guardar(modal)" [disabled]="guardando">
                <span *ngIf="!guardando">
                    <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Guardar cambios' : 'Guardar' }}
                </span>
                <span *ngIf="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span>Guardando...
                </span>
            </button>
        </div>
    </form>
</ng-template>